import styled from 'styled-components'
import { Textfield } from 'syf-component-library/ui/atoms'

export const InputField = styled(Textfield)`
  width: 100%;
`
